import React, { useRef } from "react";
import { project, ProjectElementType, status } from "@planzone/dto";

import { ElementTypes } from "@common/elementCreationForm/types";
import { Props } from "./types";
import { Task } from "../task";
import { Event } from "../event";
import { Milestone } from "../milestone";
import { List } from "../list";
import styles from "./styles.scss";

function QuickElementLoader({ type, name, parentList }: Props) {
  const dummyRef = useRef<HTMLDivElement>(null);
  const projectElement = {
    uuid: "",
    parentUuid: "",
    name: "",
    description: "",
    startDate: "",
    endDate: "",
    completionDate: "",
    percentComplete: 0,
    depth: 0,
    keyRank: 0,
    referenceKeyRank: 0,
    tags: [],
    parentUuids: [],
    activityRootUuid: "",
    attributes: {},
  };
  const meta = {
    uuid: "",
    allocatedHours: 0,
    attachmentCount: 0,
    commentCount: 0,
    elementCount: 0,
    duration: 0,
    percentComplete: 0,
    spentHours: 0,
  };

  return (
    <div
      className={styles.quickElementLoader}
      onClick={(e) => e.stopPropagation()}
    >
      {type === ElementTypes.LIST ? (
        <List
          list={{
            ...projectElement,
            name,
            type: ProjectElementType.LIST,
          }}
          meta={meta}
          parentList={parentList}
          minDate=""
          maxDate=""
          addIn={() => {}}
          addAfter={() => {}}
          isMultiProject={false}
        />
      ) : type === ElementTypes.TASK ? (
        <Task
          task={{
            ...projectElement,
            name,
            type: ProjectElementType.TASK,
            allocations: [],
            status: { ...status, uuid: "" },
          }}
          meta={meta}
          parentList={parentList}
          minDate=""
          maxDate=""
          isMultiProject
        />
      ) : type === ElementTypes.MILESTONE ? (
        <Milestone
          milestone={{
            ...projectElement,
            name,
            state: "TODO",
            type: ProjectElementType.MILESTONE,
          }}
          meta={meta}
          parentList={parentList}
          minDate=""
          maxDate=""
          isMultiProject
        />
      ) : type === ElementTypes.EVENT ? (
        <Event
          event={{
            ...projectElement,
            name,
            type: ProjectElementType.EVENT,
          }}
          meta={meta}
          parentList={parentList}
          minDate=""
          maxDate=""
          isMultiProject
        />
      ) : (
        <React.Fragment />
      )}
    </div>
  );
}

export { QuickElementLoader };
